import React from 'react';
import styles from './dangerError.module.scss';
import { ReactComponent as AlertTriangleIcon } from 'v2/icons/alert-triangle-icon.svg';
import { ErrorStepComponentProps, StepComponent } from '../../ErrorStep';

const DangerError = ({
  title,
  description,
}: ErrorStepComponentProps): StepComponent => {
  return {
    body: (
      <div className={styles.error}>
        <div>
          <AlertTriangleIcon className={styles.alertTriangleIcon} />
        </div>

        <div className={styles.description}>
          <strong>{title}</strong>
          <p>{description}</p>
        </div>
      </div>
    ),
  };
};

export default DangerError;
